import { render, staticRenderFns } from "./ArticlesCounter.vue?vue&type=template&id=0ccb8643&scoped=true"
import script from "./ArticlesCounter.vue?vue&type=script&lang=ts"
export * from "./ArticlesCounter.vue?vue&type=script&lang=ts"
import style0 from "./ArticlesCounter.vue?vue&type=style&index=0&id=0ccb8643&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccb8643",
  null
  
)

export default component.exports